__turbopack_context__.v({
  "contactButton": "PhotographerPage-module__nrk9-a__contactButton",
  "contactButtonWrapper": "PhotographerPage-module__nrk9-a__contactButtonWrapper",
  "heartIcon": "PhotographerPage-module__nrk9-a__heartIcon",
  "liked": "PhotographerPage-module__nrk9-a__liked",
  "mediaContent": "PhotographerPage-module__nrk9-a__mediaContent",
  "mediaLikes": "PhotographerPage-module__nrk9-a__mediaLikes",
  "mediaPicture": "PhotographerPage-module__nrk9-a__mediaPicture",
  "mediasGrid": "PhotographerPage-module__nrk9-a__mediasGrid",
  "photographerHeader": "PhotographerPage-module__nrk9-a__photographerHeader",
  "photographerLocation": "PhotographerPage-module__nrk9-a__photographerLocation",
  "photographerName": "PhotographerPage-module__nrk9-a__photographerName",
  "photographerPortrait": "PhotographerPage-module__nrk9-a__photographerPortrait",
  "photographerPresentation": "PhotographerPage-module__nrk9-a__photographerPresentation",
  "photographerTagline": "PhotographerPage-module__nrk9-a__photographerTagline",
  "portraitWrapper": "PhotographerPage-module__nrk9-a__portraitWrapper",
  "sideInfos": "PhotographerPage-module__nrk9-a__sideInfos",
  "tags": "PhotographerPage-module__nrk9-a__tags",
  "tagsSelect": "PhotographerPage-module__nrk9-a__tagsSelect",
});
